import { INCIDENT_SMS_WAIT_MINUTES_RANGE } from '@chukua/common';
import { Form, InputNumber } from 'antd';
import { KenyanMobileInput } from '../../../shared/components/KenyanMobileInput';
import { kenyanMobileRules } from '../../../shared/policies/kenyan-mobile-rules';

/**
 * The office number a driver's phone offers a pre-filled text to when an incident it raised has not reached the server (gitaumoses4/chukua#496).
 * Not the "Send by SMS after unseen" setting under Drivers: that is the server texting a driver, this is the phone texting the office.
 */
export function IncidentSmsFields() {
  return (
    <div className="grid gap-x-4 sm:grid-cols-2">
      <Form.Item
        name="incidentSmsNumber"
        label="Incident SMS number"
        className="mb-0"
        rules={kenyanMobileRules({ required: false })}
        extra="Where a driver's phone offers a text when an incident it raised has not synced. Leave empty to switch this off."
      >
        <KenyanMobileInput />
      </Form.Item>
      <Form.Item
        name="incidentSmsWaitMinutes"
        label="Minutes before the driver is offered the text"
        className="mb-0"
        rules={[{ required: true, message: 'Enter a number of minutes' }]}
        extra="Counted from when the driver raised the incident. The driver taps Send; nothing is sent by itself."
      >
        <InputNumber className="w-full" min={INCIDENT_SMS_WAIT_MINUTES_RANGE.min} max={INCIDENT_SMS_WAIT_MINUTES_RANGE.max} precision={0} />
      </Form.Item>
    </div>
  );
}
